import React from 'react';
import { TextField, Filter } from 'react-admin';

import makeStyles from '@material-ui/core/styles/makeStyles';

import { Actions as ListActions, Datagrid, List } from 'components/list';
import { ActionField } from 'components/fields';
import SearchInput from 'components/list/SearchInput';

import NameField from '../NameField';
import AddActionButton from './AddActionButton';
import DeleteRewardActionField from './DeleteRewardActionField';
import EditableActionPointsField from './EditableActionPointsField';
import EditActionField from './EditActionField';
import TypeField from './TypeField';

const useStyles = makeStyles((theme) => ({
  form: {
    justifyContent: 'flex-end',
    width: '100%',
    '& .filter-field': {
      width: '50%',
    },
  },
}));

const ActionsFilter = (props) => {
  const classes = useStyles();

  return (
    <Filter classes={classes} {...props}>
      <SearchInput label="Search" source="search" alwaysOn onlySearch loading={props.loading} />
    </Filter>
  );
};

const RewardActions = (props) => (
  <ListActions {...props}>
    <AddActionButton />
  </ListActions>
);

const Actions = (props) => {
  return (
    <List
      {...props}
      resource="rewardsAction"
      basePath="/rewardsSettings"
      actions={<RewardActions />}
      filters={<ActionsFilter />}>
      <Datagrid>
        <NameField source="title" imageSource="iconUrl" label="Action" />
        <TextField source="type" label="System integration" sortable={false} />
        <TypeField source="type" label="Type" sortable={false} />
        <EditableActionPointsField source="pointsAwarded" label="Points" sortable={false} />

        <ActionField>
          <EditActionField />
          <DeleteRewardActionField />
        </ActionField>
      </Datagrid>
    </List>
  );
};

export default Actions;
